import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

const swiperConfig = {
    modules: [Pagination, Navigation],
    spaceBetween: 24,
    navigation: {
        addIcons: false
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    }
};

const renderFraction = (currentClass, totalClass, separator = ' / ') => {
    return '<span class="' + currentClass + '"></span>' +
        separator +
        '<span class="' + totalClass + '"></span>';
};

const createNavigationConfig = ($next, $prev) => {
    return {
        ...swiperConfig.navigation,
        nextEl: $next,
        prevEl: $prev
    };
};

document.addEventListener('DOMContentLoaded', () => {
    const $widgetHighlightSliders = document.querySelectorAll('.widget-highlight .tab-content');
    const $widgetSmallHighlightSliders = document.querySelectorAll('.widget-highlight--small .tab-content .swiper');
    const $widgetFeatureSliders = document.querySelectorAll('.widget-feature');
    const $logoSliders = document.querySelectorAll('.widget-logo-slider');

    $widgetFeatureSliders.forEach($featureSlider => {
        let $next = $featureSlider.querySelector('.fa-arrow-right-long');
        let $prev = $featureSlider.querySelector('.fa-arrow-left-long');
        let $swiper = $featureSlider.querySelector('.swiper');
        $featureSlider.swiperInstance = new Swiper($swiper, {
            ...swiperConfig,
            slidesPerView: 1.2,
            breakpoints: {
                640: {
                    slidesPerView: 2.2
                },
                1024: {
                    slidesPerView: 3
                }
            },
            navigation: createNavigationConfig($next, $prev),
            renderFraction: function (currentClass, totalClass) {
                return renderFraction(currentClass, totalClass);
            }
        });
    });

    if ($widgetHighlightSliders.length) {
        const breakpoint = window.matchMedia('(min-width:1216px)');
        const breakpointChecker = function () {
            if (breakpoint.matches === true) {
                $widgetHighlightSliders.forEach($highlightSlider => {
                    if ($highlightSlider.swiperInstance !== undefined && $highlightSlider.swiperInstance.initialized) {
                        $highlightSlider.swiperInstance.destroy(true, true);
                    }
                });
                return;
            } else if (breakpoint.matches === false) {
                $widgetHighlightSliders.forEach($highlightSlider => {
                    let $next = $highlightSlider.querySelector('.fa-arrow-right-long');
                    let $prev = $highlightSlider.querySelector('.fa-arrow-left-long');
                    let $swiper = $highlightSlider.querySelector('.swiper');
                    $highlightSlider.swiperInstance = new Swiper($swiper, {
                        ...swiperConfig,
                        slidesPerView: 1.2,
                        breakpoints: {
                            480: {
                                slidesPerView: 2.2
                            },
                            769: {
                                slidesPerView: 3.2
                            },
                            1024: {
                                slidesPerView: 3
                            }
                        },
                        navigation: createNavigationConfig($next, $prev),
                        renderFraction: function (currentClass, totalClass) {
                            return renderFraction(currentClass, totalClass);
                        }
                    });
                });
            }
        };

        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
    }

    $widgetSmallHighlightSliders.forEach($smallHighlightSlider => {
        let $next = $smallHighlightSlider.querySelector('.fa-arrow-right-long');
        let $prev = $smallHighlightSlider.querySelector('.fa-arrow-left-long');
        new Swiper($smallHighlightSlider, {
            ...swiperConfig,
            slidesPerView: 1.2,
            breakpoints: {
                480: {
                    slidesPerView: 2.2
                },
                769: {
                    slidesPerView: 3.2
                },
                1024: {
                    slidesPerView: 3
                },
                1216: {
                    slidesPerView: 4
                }
            },
            navigation: createNavigationConfig($next, $prev),
            renderFraction: function (currentClass, totalClass) {
                return renderFraction(currentClass, totalClass);
            }
        });
    });

    $logoSliders.forEach($logoSlider => {
        let $next = $logoSlider.querySelector('.fa-arrow-right-long');
        let $prev = $logoSlider.querySelector('.fa-arrow-left-long');
        new Swiper($logoSlider, {
            ...swiperConfig,
            slidesPerView: 'auto',
            spaceBetween: 45,
            navigation: createNavigationConfig($next, $prev),
            renderFraction: function (currentClass, totalClass) {
                return renderFraction(currentClass, totalClass, ' of ');
            }
        });
    });
});
